export const CUSTOM_FIELD_TYPES = {
  OPEN: 'abierta',
  CLOSED: 'cerrada'
};

/**
 * Misma convención que el selector de tipo de pregunta de la creación de vacante
 * (client/js/crud_vacancy/components/question.js). El `label` va como literal, sin i18n,
 * igual que en el componente original. Los `value` son contrato: se persisten.
 */
export const customFieldTypeOptions = [
  {
    label: 'abierta',
    value: CUSTOM_FIELD_TYPES.OPEN
  },
  {
    label: 'cerrada',
    value: CUSTOM_FIELD_TYPES.CLOSED
  }
];

/**
 * Las tres pestañas del form de plantilla, con los mismos identificadores que usa
 * template-request-form/index.jsx. Los campos custom están disponibles en las tres.
 * Van como string y no como índice: reordenar las pestañas no debe corromper los datos.
 */
export const CUSTOM_FIELD_TABS = {
  GENERAL: 'general',
  VACANCY_DETAILS: 'vacancyDetails',
  CANDIDATE_DETAILS: 'candidateDetails'
};

export const emptyCustomFieldsByTab = () => ({
  [CUSTOM_FIELD_TABS.GENERAL]: [],
  [CUSTOM_FIELD_TABS.VACANCY_DETAILS]: [],
  [CUSTOM_FIELD_TABS.CANDIDATE_DETAILS]: []
});

export const MAX_CUSTOM_FIELDS_PER_TAB = 5;
// Mínimo de opciones de un campo cerrado, y con cuántas arranca. Es un mínimo de verdad: el tacho se
// bloquea al llegar acá y el modal no deja confirmar por debajo. Tiene que coincidir con
// MIN_CUSTOM_FIELD_OPTIONS del validador del api.
export const MIN_CLOSED_FIELD_OPTIONS = 2;
export const MAX_CLOSED_FIELD_OPTIONS = 20;
export const CUSTOM_FIELD_NAME_MAX_LENGTH = 100;
// 1000 sale del contador del diseño (0/1000). Tiene que coincidir con el validador del api.
export const CUSTOM_FIELD_LABEL_MAX_LENGTH = 1000;
